import React from 'react';
import { MotifButton } from '@ey-xd/motif-react';
import styles from './button.module.scss';

interface Props {
    type: 'primary' | 'primary-alt' | 'secondary' | 'ghost' | 'text' | 'text-alt' | 'warn';
    disabled?: boolean;
    label: string;
    onClick?: () => void;
    icon?: React.ReactNode;
    className?: string;
    title?: string;
    width?: React.CSSProperties['width'];
}

const ButtonComponent: React.FC<Props> = ({ label, type, disabled, onClick, icon, className, title, width }) => (
    <MotifButton
        size='small'
        type='submit'
        variant={type}
        disabled={disabled}
        onClick={onClick}
        style={
            width !== undefined
                ? ({ '--button-width': typeof width === 'number' ? `${width}px` : width } as React.CSSProperties)
                : undefined
        }
        className={`${styles[type]} ${width !== undefined ? styles['width-override'] : ''} ${className ?? ''}`.trim()}
        title={title}
        data-testid={label}
        onKeyDown={(event: any) => {
            if (event.key === 'Enter' || event.key === ' ') {
                onClick && onClick();
            }
        }}
    >
        {icon && <span className='nexus-icon'>{icon}</span>}
        <span className='nexus-body'>{label}</span>
    </MotifButton>
);

export default ButtonComponent;
